import subDays from "date-fns/subDays";
import subMonths from "date-fns/subMonths";
import {
  DEFAULT_PERIOD_OPTIONS,
  type DefaultPeriod,
} from "../../../components/features/AiAssistantTemplateForm/validationSchema";

export type DateRange = {
  startDate: Date;
  endDate: Date;
};

export const DEFAULT_INITIAL_PERIOD: DefaultPeriod = "two_weeks";

export const convertDefaultPeriodToDateRange = (
  defaultPeriod: DefaultPeriod,
  referenceDate: Date,
): DateRange => {
  switch (defaultPeriod) {
    case "week":
      return { startDate: subDays(referenceDate, 7), endDate: referenceDate };
    case "two_weeks":
      return { startDate: subDays(referenceDate, 14), endDate: referenceDate };
    case "month":
      return { startDate: subMonths(referenceDate, 1), endDate: referenceDate };
    case "three_months":
      return { startDate: subMonths(referenceDate, 3), endDate: referenceDate };
  }
};

export const PRESET_PERIODS: readonly DefaultPeriod[] =
  DEFAULT_PERIOD_OPTIONS.map((option) => option.value);

export const PRESET_PERIOD_LABELS: Record<DefaultPeriod, string> =
  Object.fromEntries(
    DEFAULT_PERIOD_OPTIONS.map((option) => [option.value, option.label]),
  ) as Record<DefaultPeriod, string>;
